import { auth } from '../../firebase';
import { signOut } from 'firebase/auth';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setUser } from '../store/usersSlice';
import { useNavigate } from "react-router-dom";
import { ReactComponent as SettingIcon } from '../../assets/settings.svg';
import { ReactComponent as HomeIcon } from '../../assets/home.svg';
import { ReactComponent as LogoutIcon } from '../../assets/logout.svg';
import { ReactComponent as ListIcon } from '../../assets/file.svg';
import { ReactComponent as AboutIcon } from '../../assets/about.svg';

export default function NavBar() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleSignOut = () => {
    signOut(auth).then(() => {
      dispatch(setUser(null));
      navigate("/");
    })
  }

  return (
    <>
      <nav className='NavBar'>
        <ul>
          <Link className="NavLink" to="/">
           <HomeIcon className="btnIcon" />
            Home
          </Link>
          <Link className="NavLink" to="/addedlists">
            <ListIcon className="btnIcon" />
            Added Lists
          </Link>
          <Link className="NavLink" to="/about">
            <AboutIcon className="btnIcon" />
            About
          </Link>
          <Link className="NavLink" to="/settings">
            <SettingIcon className="btnIcon" />
            Settings
          </Link>
          <button onClick={handleSignOut}>
            <LogoutIcon className="btnIcon" />
            Logout
          </button>
        </ul>
      </nav>
    </>
  )
}
